var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-view" },
    [
      _c("div", { staticClass: "tv-main" }, [
        _c("div", { staticClass: "tv-filter-row" }, [
          _c(
            "div",
            { staticClass: "tv-area-row" },
            [
              _c(
                "div",
                {
                  staticClass: "area-pill",
                  class: { active: _vm.activeArea === 0 },
                  on: {
                    click: function ($event) {
                      _vm.activeArea = 0
                    },
                  },
                },
                [_vm._v("全部")]
              ),
              _vm._l(_vm.areas, function (a) {
                return _c(
                  "div",
                  {
                    key: a.id,
                    staticClass: "area-pill",
                    class: { active: _vm.activeArea === a.id },
                    on: {
                      click: function ($event) {
                        _vm.activeArea = a.id
                      },
                    },
                  },
                  [_vm._v(_vm._s(a.name))]
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "tv-type-row" },
            [
              _c(
                "div",
                {
                  staticClass: "type-pill",
                  class: { active: _vm.activeType === 0 },
                  on: {
                    click: function ($event) {
                      _vm.activeType = 0
                    },
                  },
                },
                [_vm._v("全部")]
              ),
              _vm._l(_vm.typeTabs, function (tt) {
                return _c(
                  "div",
                  {
                    key: tt.id,
                    staticClass: "type-pill",
                    class: { active: _vm.activeType === tt.id },
                    on: {
                      click: function ($event) {
                        _vm.activeType = tt.id
                      },
                    },
                  },
                  [_vm._v(_vm._s(tt.name) + "(" + _vm._s(tt.count) + ")")]
                )
              }),
            ],
            2
          ),
        ]),
        _c(
          "div",
          { staticClass: "tv-grid-scroll" },
          [
            _vm.loading && _vm.tables.length === 0
              ? _c("a-icon", {
                  staticClass: "tv-loading",
                  attrs: { type: "loading" },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "tv-grid" },
              _vm._l(_vm.filteredTables, function (t) {
                return _c(
                  "div",
                  {
                    key: t.id,
                    staticClass: "tcard",
                    class: [
                      _vm.cardClass(t),
                      { selected: t.id === _vm.selectedTableId },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onTableClick(t)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "tcard-name" }, [
                      _vm._v(_vm._s(t.name)),
                    ]),
                    t.status === "3"
                      ? [
                          _c("div", { staticClass: "tcard-status" }, [
                            _vm._v("就餐中"),
                          ]),
                          _c("div", { staticClass: "tcard-sub" }, [
                            _vm._v(
                              "就餐时长 " + _vm._s(t.diningMinutes) + "分钟"
                            ),
                          ]),
                          _c("div", { staticClass: "tcard-sub" }, [
                            _vm._v(
                              _vm._s(_vm.peopleOf(t)) +
                                "人 / " +
                                _vm._s(t.capacity || "-") +
                                "座"
                            ),
                          ]),
                        ]
                      : t.status === "2"
                      ? [
                          _c("div", { staticClass: "tcard-status" }, [
                            _vm._v("已开台"),
                          ]),
                        ]
                      : t.status === "reserved"
                      ? [
                          _c("div", { staticClass: "tcard-status" }, [
                            _vm._v("已预订"),
                          ]),
                        ]
                      : [
                          _c("div", { staticClass: "tcard-seats" }, [
                            _vm._v(_vm._s(t.capacity || "-") + "座"),
                          ]),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
            !_vm.loading && _vm.filteredTables.length === 0
              ? _c("div", { staticClass: "tv-empty" }, [
                  _vm._v("\n        暂无桌台，请先在管理端配置桌台\n      "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tv-footer" },
          [
            _vm._m(0),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  icon: "reload",
                  size: "small",
                  loading: _vm.loading,
                },
                on: { click: _vm.refreshAll },
              },
              [_vm._v("刷新")]
            ),
            _c("span", { staticClass: "tv-foot-text" }, [
              _vm._v("结算模式：" + _vm._s(_vm.payModeText)),
            ]),
            _c("span", { staticClass: "tv-foot-text" }, [
              _vm._v("点餐模式：" + _vm._s(_vm.orderModeText)),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "tv-actionbar" }, [
          _c("div", { staticClass: "ab-left" }, [
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.handleClearAll } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "delete" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("整单清空")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.openMemberModal } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "team" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("会员")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.openChangePriceModal } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "pay-circle-o" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("商品改价")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.openDiscountModal } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "gift" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("折扣抹零")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.openChangeModal } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "swap" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("转台")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.openDepositModal } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "wallet" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("预收订金")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.handlePrintPreSettle } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "printer" },
                }),
                _c("span", { staticClass: "abtn-text" }, [
                  _vm._v("打印预结单"),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "ab-right" }, [
            _c(
              "div",
              { staticClass: "abtn", on: { click: _vm.assistOrder } },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "edit" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("协助点餐")]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "abtn abtn-primary",
                on: { click: _vm.handleSettle },
              },
              [
                _c("a-icon", {
                  staticClass: "abtn-icon",
                  attrs: { type: "pay-circle" },
                }),
                _c("span", { staticClass: "abtn-text" }, [_vm._v("结账")]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "tv-side" },
        [
          _vm.selectedTable
            ? [
                _c("div", { staticClass: "side-title" }, [
                  _vm._v("桌台：" + _vm._s(_vm.selectedTable.name)),
                ]),
                _c("div", { staticClass: "side-info" }, [
                  _c("div", { staticClass: "side-row" }, [
                    _c("span", { staticClass: "side-label" }, [_vm._v("人数")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.peopleOf(_vm.selectedTable)) + "人"),
                    ]),
                  ]),
                  _c("div", { staticClass: "side-row" }, [
                    _c("span", { staticClass: "side-label" }, [
                      _vm._v("座位数"),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.selectedTable.capacity || "-") + "座"),
                    ]),
                  ]),
                  _c("div", { staticClass: "side-row" }, [
                    _c("span", { staticClass: "side-label" }, [
                      _vm._v("订单来源"),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.sourceOf(_vm.selectedTable))),
                    ]),
                  ]),
                  _vm.selectedTable.status === "3"
                    ? _c("div", { staticClass: "side-row" }, [
                        _c("span", { staticClass: "side-label" }, [
                          _vm._v("就餐时长"),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.selectedTable.diningMinutes) + "分钟"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm.selectedOrder
                  ? [
                      _c(
                        "div",
                        { staticClass: "side-order-head" },
                        [
                          _c("span", { staticClass: "side-order-no" }, [
                            _vm._v(_vm._s(_vm.selectedOrder.order_no)),
                          ]),
                          _vm.boundMember
                            ? _c(
                                "a-tag",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: { color: "gold" },
                                },
                                [_vm._v(_vm._s(_vm.boundMember))]
                              )
                            : _vm._e(),
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.orderTagColor(
                                  _vm.selectedOrder.status
                                ),
                              },
                            },
                            [_vm._v(_vm._s(_vm.selectedOrder.statusText))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "side-items" },
                        [
                          _vm.detailLoading
                            ? _c("a-icon", {
                                staticClass: "side-loading",
                                attrs: { type: "loading" },
                              })
                            : [
                                _vm._l(_vm.selectedOrder.items, function (it) {
                                  return _c(
                                    "div",
                                    {
                                      key: it.id,
                                      staticClass: "side-item",
                                      class: {
                                        "side-item-active":
                                          it.id === _vm.selectedItemId,
                                        "side-item-returned":
                                          _vm.isReturned(it),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectedItemId = it.id
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "si-name" }, [
                                        _vm._v(_vm._s(it.material_name)),
                                      ]),
                                      _c("span", { staticClass: "si-qty" }, [
                                        _vm._v("x" + _vm._s(it.quantity)),
                                      ]),
                                      _c("span", { staticClass: "si-amount" }, [
                                        _vm._v(
                                          "¥" + _vm._s(_vm.fmt(it.all_price))
                                        ),
                                      ]),
                                      _vm.isReturned(it)
                                        ? _c(
                                            "a-tag",
                                            {
                                              staticClass: "si-returned-tag",
                                              attrs: {
                                                color: "red",
                                                title: it.return_reason || "",
                                              },
                                            },
                                            [_vm._v("已退")]
                                          )
                                        : _c(
                                            "a-button",
                                            {
                                              staticClass: "si-return-btn",
                                              attrs: {
                                                size: "small",
                                                type: "danger",
                                                ghost: "",
                                                icon: "rollback",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.openReturnModal(it)
                                                },
                                              },
                                            },
                                            [_vm._v("退")]
                                          ),
                                    ],
                                    1
                                  )
                                }),
                                !_vm.selectedOrder.items ||
                                _vm.selectedOrder.items.length === 0
                                  ? _c("div", { staticClass: "side-hint" }, [
                                      _vm._v('暂无菜品，可点"加菜"开始点餐'),
                                    ])
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "side-total" }, [
                        _c("span", [_vm._v("合计")]),
                        _c("span", { staticClass: "side-total-amount" }, [
                          _vm._v(
                            "¥" +
                              _vm._s(_vm.fmt(_vm.selectedOrder.total_amount))
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "side-actions" },
                        [
                          _vm.canReceive
                            ? _c(
                                "a-button",
                                {
                                  attrs: {
                                    block: "",
                                    type: "primary",
                                    icon: "check",
                                    loading: _vm.receiving,
                                  },
                                  on: { click: _vm.handleReceive },
                                },
                                [_vm._v("接单")]
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              attrs: { block: "", icon: "plus" },
                              on: {
                                click: function ($event) {
                                  return _vm.gotoOrder(
                                    _vm.selectedTable.id,
                                    _vm.selectedOrder.id
                                  )
                                },
                              },
                            },
                            [_vm._v("加菜")]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm.selectedTable.status === "3"
                  ? _c("div", { staticClass: "side-hint" }, [
                      _vm._v("桌台状态同步中，请刷新后重试"),
                    ])
                  : _c("div", { staticClass: "side-hint" }, [
                      _vm._v("该桌台尚未开台，点击桌台卡片可开台点餐"),
                    ]),
              ]
            : _c(
                "div",
                { staticClass: "side-default" },
                [
                  _c("a-icon", {
                    staticClass: "side-default-icon",
                    attrs: { type: "info-circle" },
                  }),
                  _c("div", [_vm._v("点选已开台桌台，可以在此查看点餐信息。")]),
                ],
                1
              ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "开台",
            visible: _vm.openVisible,
            "confirm-loading": _vm.opening,
            maskClosable: false,
          },
          on: {
            ok: _vm.confirmOpen,
            cancel: function ($event) {
              _vm.openVisible = false
            },
          },
        },
        [
          _vm.openTable
            ? _c("div", { staticClass: "open-form" }, [
                _c("div", { staticClass: "open-row" }, [
                  _c("span", { staticClass: "open-label" }, [_vm._v("桌台")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.openTable.name) +
                        "（" +
                        _vm._s(_vm.openTable.capacity || "-") +
                        "座）"
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "open-row" },
                  [
                    _c("span", { staticClass: "open-label" }, [_vm._v("人数")]),
                    _c("a-input-number", {
                      attrs: { min: 1, max: 99, precision: 0 },
                      model: {
                        value: _vm.openPeople,
                        callback: function ($$v) {
                          _vm.openPeople = $$v
                        },
                        expression: "openPeople",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "open-row" },
                  [
                    _c("span", { staticClass: "open-label" }, [
                      _vm._v("订单来源"),
                    ]),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "180px" },
                        model: {
                          value: _vm.openSource,
                          callback: function ($$v) {
                            _vm.openSource = $$v
                          },
                          expression: "openSource",
                        },
                      },
                      _vm._l(_vm.orderSources, function (s) {
                        return _c(
                          "a-select-option",
                          { key: s, attrs: { value: s } },
                          [_vm._v(_vm._s(s))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "转台",
            visible: _vm.changeVisible,
            "confirm-loading": _vm.changing,
            maskClosable: false,
          },
          on: {
            ok: _vm.confirmChange,
            cancel: function ($event) {
              _vm.changeVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "cascade-form" }, [
            _c(
              "div",
              { staticClass: "cascade-row" },
              [
                _c("span", { staticClass: "cascade-label" }, [
                  _c("i", { staticClass: "req" }, [_vm._v("*")]),
                  _vm._v("所属区域"),
                ]),
                _c(
                  "a-select",
                  {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: "请选择区域",
                      getPopupContainer: (trigger) => trigger.parentElement,
                    },
                    on: { change: _vm.onChangeArea },
                    model: {
                      value: _vm.changeAreaId,
                      callback: function ($$v) {
                        _vm.changeAreaId = $$v
                      },
                      expression: "changeAreaId",
                    },
                  },
                  _vm._l(_vm.areas, function (a) {
                    return _c(
                      "a-select-option",
                      { key: a.id, attrs: { value: a.id } },
                      [_vm._v(_vm._s(a.name))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "cascade-row" },
              [
                _c("span", { staticClass: "cascade-label" }, [
                  _c("i", { staticClass: "req" }, [_vm._v("*")]),
                  _vm._v("桌位类型"),
                ]),
                _c(
                  "a-select",
                  {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: "请选择桌位类型",
                      getPopupContainer: (trigger) => trigger.parentElement,
                    },
                    on: { change: _vm.onChangeType },
                    model: {
                      value: _vm.changeTypeId,
                      callback: function ($$v) {
                        _vm.changeTypeId = $$v
                      },
                      expression: "changeTypeId",
                    },
                  },
                  _vm._l(_vm.changeTypeOptions, function (tt) {
                    return _c(
                      "a-select-option",
                      { key: tt.id, attrs: { value: tt.id } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(tt.name) +
                            "(" +
                            _vm._s(tt.count) +
                            "张)\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "cascade-row" },
              [
                _c("span", { staticClass: "cascade-label" }, [
                  _c("i", { staticClass: "req" }, [_vm._v("*")]),
                  _vm._v("桌台编号"),
                ]),
                _c(
                  "a-select",
                  {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: "请选择空闲桌台",
                      getPopupContainer: (trigger) => trigger.parentElement,
                    },
                    model: {
                      value: _vm.changeTargetId,
                      callback: function ($$v) {
                        _vm.changeTargetId = $$v
                      },
                      expression: "changeTargetId",
                    },
                  },
                  _vm._l(_vm.changeTableOptions, function (t) {
                    return _c(
                      "a-select-option",
                      { key: t.id, attrs: { value: t.id } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(t.name) +
                            "（" +
                            _vm._s(t.capacity || "-") +
                            "座）\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "change-tip" }, [
              _vm._v("确定转台后，原桌将释放为未就餐状态，订单号保持不变"),
            ]),
          ]),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "查询会员",
            visible: _vm.memberVisible,
            footer: null,
            width: "520px",
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.memberVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "member-tip" }, [
            _vm._v("\n      请输入会员手机号查询会员，输入完毕后点击确认"),
            _c("br"),
            _vm._v(
              "\n      （若会员未绑定手机号，可通过会员手机号或通过扫码枪扫描二维码登录会员）\n    "
            ),
          ]),
          _vm.boundMemberInfo
            ? _c(
                "div",
                { staticClass: "member-card" },
                [
                  _c(
                    "div",
                    { staticClass: "member-card-row" },
                    [
                      _c("span", { staticClass: "member-card-name" }, [
                        _vm._v(_vm._s(_vm.boundMemberInfo.name)),
                      ]),
                      _vm.boundMemberInfo.levelName
                        ? _c("a-tag", { attrs: { color: "gold" } }, [
                            _vm._v(_vm._s(_vm.boundMemberInfo.levelName)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "member-card-row member-card-sub" },
                    [
                      _c("span", [
                        _vm._v(
                          "手机号：" + _vm._s(_vm.boundMemberInfo.phone || "—")
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          "余额：¥" +
                            _vm._s(_vm.fmt(_vm.boundMemberInfo.balance))
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        block: "",
                        type: "danger",
                        loading: _vm.memberLoading,
                      },
                      on: { click: _vm.unbindMember },
                    },
                    [_vm._v("解绑会员")]
                  ),
                ],
                1
              )
            : _vm.memberQueryResult
            ? _c("div", { staticClass: "member-card" }, [
                _c(
                  "div",
                  { staticClass: "member-card-row" },
                  [
                    _c("span", { staticClass: "member-card-name" }, [
                      _vm._v(_vm._s(_vm.memberQueryResult.name)),
                    ]),
                    _vm.memberQueryResult.levelName
                      ? _c("a-tag", { attrs: { color: "gold" } }, [
                          _vm._v(_vm._s(_vm.memberQueryResult.levelName)),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "member-card-row member-card-sub" }, [
                  _c("span", [
                    _vm._v(
                      "手机号：" + _vm._s(_vm.memberQueryResult.phone || "—")
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      "余额：¥" + _vm._s(_vm.fmt(_vm.memberQueryResult.balance))
                    ),
                  ]),
                ]),
                _vm.selectedOrder && _vm.selectedOrder.member_id
                  ? _c("div", { staticClass: "member-bound-hint" }, [
                      _vm._v("\n        确定后将替换当前绑定会员\n      "),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "member-card-actions" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "large" },
                        on: { click: _vm.cancelMemberQuery },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          size: "large",
                          type: "primary",
                          loading: _vm.memberLoading,
                        },
                        on: { click: _vm.confirmBindMember },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                ),
              ])
            : [
                _vm.selectedOrder && _vm.selectedOrder.member_id
                  ? _c("div", { staticClass: "member-bound-hint" }, [
                      _vm._v(
                        "\n        该订单已绑定会员，查询新会员后将替换绑定\n      "
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "np-input-row" },
                  [
                    _c(
                      "a-input",
                      {
                        ref: "memberPhoneInput",
                        staticClass: "np-input",
                        attrs: {
                          placeholder: "请输入会员手机号（支持扫码枪）",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchMemberByPhone.apply(
                              null,
                              arguments
                            )
                          },
                        },
                        model: {
                          value: _vm.memberPhone,
                          callback: function ($$v) {
                            _vm.memberPhone = $$v
                          },
                          expression: "memberPhone",
                        },
                      },
                      [
                        _c("a-icon", {
                          staticClass: "np-input-icon",
                          attrs: { slot: "prefix", type: "search" },
                          slot: "prefix",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("num-pad", {
                  attrs: { dot: false },
                  on: { confirm: _vm.searchMemberByPhone },
                  model: {
                    value: _vm.memberPhone,
                    callback: function ($$v) {
                      _vm.memberPhone = $$v
                    },
                    expression: "memberPhone",
                  },
                }),
              ],
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "商品改价",
            visible: _vm.priceVisible,
            footer: null,
            width: "520px",
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.priceVisible = false
            },
          },
        },
        [
          _vm.priceItem
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "np-field" }, [
                    _c("span", { staticClass: "np-field-label" }, [
                      _vm._v("当前价格"),
                    ]),
                    _c("span", { staticClass: "np-field-value np-blue" }, [
                      _vm._v("¥" + _vm._s(_vm.fmt(_vm.priceItem.unit_price))),
                    ]),
                  ]),
                  _c("div", { staticClass: "np-field" }, [
                    _c("span", { staticClass: "np-field-label" }, [
                      _c("i", { staticClass: "req" }, [_vm._v("*")]),
                      _vm._v("本次售价"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "np-suffix-row" },
                      [
                        _c("a-input", {
                          staticClass: "np-input",
                          attrs: { readonly: "", placeholder: "0.00" },
                          model: {
                            value: _vm.priceValue,
                            callback: function ($$v) {
                              _vm.priceValue = $$v
                            },
                            expression: "priceValue",
                          },
                        }),
                        _c("span", { staticClass: "np-suffix" }, [
                          _vm._v("元"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("num-pad", {
                    on: { confirm: _vm.confirmChangePrice },
                    model: {
                      value: _vm.priceValue,
                      callback: function ($$v) {
                        _vm.priceValue = $$v
                      },
                      expression: "priceValue",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "side-hint" }, [
                _vm._v("请先在右侧点选要改价的菜品行"),
              ]),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "折扣抹零",
            visible: _vm.discountVisible,
            width: "520px",
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.discountVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "np-field" }, [
            _c("span", { staticClass: "np-field-label" }, [_vm._v("原价")]),
            _c("span", { staticClass: "np-field-value np-green" }, [
              _vm._v("¥" + _vm._s(_vm.fmt(_vm.orderPayable))),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "np-field" },
            [
              _c("span", { staticClass: "np-field-label" }, [
                _vm._v("优惠类型"),
              ]),
              _c(
                "a-radio-group",
                {
                  staticClass: "touch-radio",
                  attrs: { "button-style": "solid", size: "large" },
                  model: {
                    value: _vm.discountType,
                    callback: function ($$v) {
                      _vm.discountType = $$v
                    },
                    expression: "discountType",
                  },
                },
                [
                  _c("a-radio-button", { attrs: { value: "change" } }, [
                    _vm._v("改价"),
                  ]),
                  _c("a-radio-button", { attrs: { value: "discount" } }, [
                    _vm._v("折扣"),
                  ]),
                  _c("a-radio-button", { attrs: { value: "erase" } }, [
                    _vm._v("抹零"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.discountType === "change"
            ? [
                _c("div", { staticClass: "np-field" }, [
                  _c("span", { staticClass: "np-field-label" }, [
                    _c("i", { staticClass: "req" }, [_vm._v("*")]),
                    _vm._v("实付价格"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "np-suffix-row" },
                    [
                      _c("a-input", {
                        staticClass: "np-input",
                        attrs: { readonly: "", placeholder: "0.00" },
                        model: {
                          value: _vm.discountChangeValue,
                          callback: function ($$v) {
                            _vm.discountChangeValue = $$v
                          },
                          expression: "discountChangeValue",
                        },
                      }),
                      _c("span", { staticClass: "np-suffix" }, [_vm._v("元")]),
                    ],
                    1
                  ),
                ]),
                _c("num-pad", {
                  on: { confirm: _vm.confirmDiscount },
                  model: {
                    value: _vm.discountChangeValue,
                    callback: function ($$v) {
                      _vm.discountChangeValue = $$v
                    },
                    expression: "discountChangeValue",
                  },
                }),
              ]
            : _vm.discountType === "discount"
            ? [
                _c("div", { staticClass: "np-field" }, [
                  _c("span", { staticClass: "np-field-label" }, [
                    _c("i", { staticClass: "req" }, [_vm._v("*")]),
                    _vm._v("优惠折扣"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "np-suffix-row" },
                    [
                      _c("a-input", {
                        staticClass: "np-input",
                        attrs: { readonly: "", placeholder: "如 7 表示 7 折" },
                        model: {
                          value: _vm.discountRateInput,
                          callback: function ($$v) {
                            _vm.discountRateInput = $$v
                          },
                          expression: "discountRateInput",
                        },
                      }),
                      _c("span", { staticClass: "np-suffix" }, [_vm._v("折")]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "discount-hint" }, [
                  _vm._v("折后应付：¥" + _vm._s(_vm.discountedPreview)),
                ]),
                _c("num-pad", {
                  attrs: { dot: false },
                  on: { confirm: _vm.confirmDiscount },
                  model: {
                    value: _vm.discountRateInput,
                    callback: function ($$v) {
                      _vm.discountRateInput = $$v
                    },
                    expression: "discountRateInput",
                  },
                }),
              ]
            : _vm.discountType === "erase"
            ? [
                _c("div", { staticClass: "erase-btns" }, [
                  _c(
                    "div",
                    {
                      staticClass: "erase-btn",
                      class: { active: _vm.discountEraseRule === 1 },
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          _vm.discountEraseRule = 1
                        },
                      },
                    },
                    [_vm._v("抹分")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "erase-btn",
                      class: { active: _vm.discountEraseRule === 2 },
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          _vm.discountEraseRule = 2
                        },
                      },
                    },
                    [_vm._v("抹角")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "erase-btn",
                      class: { active: _vm.discountEraseRule === 3 },
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          _vm.discountEraseRule = 3
                        },
                      },
                    },
                    [_vm._v("四舍五入到角")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "erase-btn",
                      class: { active: _vm.discountEraseRule === 4 },
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          _vm.discountEraseRule = 4
                        },
                      },
                    },
                    [_vm._v("四舍五入到元")]
                  ),
                ]),
                _c("div", { staticClass: "erase-result" }, [
                  _vm._v("抹零后应付："),
                  _c("span", { staticClass: "np-green" }, [
                    _vm._v("¥" + _vm._s(_vm.erasePreview)),
                  ]),
                ]),
              ]
            : _c("div", { staticClass: "side-hint" }, [
                _vm._v("请选择优惠类型"),
              ]),
          _c(
            "div",
            {
              staticClass: "discount-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "a-button",
                {
                  attrs: { loading: _vm.discountLoading },
                  on: { click: _vm.clearDiscount },
                },
                [_vm._v("清除优惠")]
              ),
              _vm.discountType === "erase"
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.discountLoading },
                      on: { click: _vm.confirmDiscount },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "整单清空",
            visible: _vm.clearVisible,
            maskClosable: false,
            width: "520px",
            "confirm-loading": _vm.clearLoading,
            "ok-text": "确认清空",
            "ok-type": "danger",
          },
          on: {
            ok: _vm.confirmClear,
            cancel: function ($event) {
              _vm.clearVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "clear-tip" }, [
            _vm._v(
              "\n      清空后整单作废并释放桌台（还原为未就餐状态），此操作不可恢复，请谨慎操作！"
            ),
            _c("br"),
            _vm._v("\n      作废后将打印作废通知单至厨房与传菜部。\n    "),
          ]),
          _c(
            "div",
            { staticClass: "np-field" },
            [
              _c("span", { staticClass: "np-field-label" }, [
                _c("i", { staticClass: "req" }, [_vm._v("*")]),
                _vm._v("清空原因"),
              ]),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择常用清空原因",
                    getPopupContainer: (trigger) => trigger.parentElement,
                  },
                  model: {
                    value: _vm.clearRemark,
                    callback: function ($$v) {
                      _vm.clearRemark = $$v
                    },
                    expression: "clearRemark",
                  },
                },
                _vm._l(_vm.clearReasons, function (r) {
                  return _c(
                    "a-select-option",
                    { key: r, attrs: { value: r } },
                    [_vm._v(_vm._s(r))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "np-field" },
            [
              _c("span", { staticClass: "np-field-label" }, [
                _vm._v("自定义原因"),
              ]),
              _c("a-input", {
                attrs: {
                  placeholder: "或直接输入自定义原因（优先于下拉选择）",
                  maxLength: 100,
                },
                model: {
                  value: _vm.clearCustomRemark,
                  callback: function ($$v) {
                    _vm.clearCustomRemark = $$v
                  },
                  expression: "clearCustomRemark",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "预收订金",
            visible: _vm.depositVisible,
            footer: null,
            width: "520px",
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.depositVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "np-field" }, [
            _c("span", { staticClass: "np-field-label" }, [
              _vm._v("已预收金额"),
            ]),
            _c("span", { staticClass: "np-field-value np-blue" }, [
              _vm._v("¥" + _vm._s(_vm.fmt(_vm.depositTotal))),
            ]),
          ]),
          _c("div", { staticClass: "np-field" }, [
            _c("span", { staticClass: "np-field-label" }, [
              _c("i", { staticClass: "req" }, [_vm._v("*")]),
              _vm._v("本次预收"),
            ]),
            _c(
              "div",
              { staticClass: "np-suffix-row" },
              [
                _c("a-input", {
                  staticClass: "np-input",
                  attrs: { readonly: "", placeholder: "0.00" },
                  model: {
                    value: _vm.depositValue,
                    callback: function ($$v) {
                      _vm.depositValue = $$v
                    },
                    expression: "depositValue",
                  },
                }),
                _c("span", { staticClass: "np-suffix" }, [_vm._v("元")]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "member-tip" }, [
            _vm._v("客人提前在收银台预存的金额，餐后结算时自动抵扣应付"),
          ]),
          _c("num-pad", {
            on: { confirm: _vm.confirmDeposit },
            model: {
              value: _vm.depositValue,
              callback: function ($$v) {
                _vm.depositValue = $$v
              },
              expression: "depositValue",
            },
          }),
        ],
        1
      ),
      _c("return-item-modal", {
        attrs: {
          visible: _vm.returnVisible,
          "item-name": _vm.returnTarget ? _vm.returnTarget.material_name : "",
          loading: _vm.returnLoading,
        },
        on: {
          cancel: function ($event) {
            _vm.returnVisible = false
          },
          confirm: _vm.confirmReturn,
        },
      }),
      _c("print-modal", { ref: "printModal" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tv-legend" }, [
      _c("span", { staticClass: "lg-item" }, [
        _c("i", { staticClass: "lg-dot lg-gray" }),
        _vm._v("未开台"),
      ]),
      _c("span", { staticClass: "lg-item" }, [
        _c("i", { staticClass: "lg-dot lg-green" }),
        _vm._v("已开台"),
      ]),
      _c("span", { staticClass: "lg-item" }, [
        _c("i", { staticClass: "lg-dot lg-orange" }),
        _vm._v("就餐中"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }